export default "__VITE_ASSET__BELz79RF__"